

const isKeyPresent = (array, key) =>
  array.filter(item => item?.split('.')[0] === key).length === array.length

export const addTabKeyToOptions = (options, key) => {
  if (isKeyPresent(Object.keys(options), key))
    return options
  return Object.entries(options).reduce((acc, [origKey, val]) => {
    acc[`${key}.${origKey}`] = val
    return acc
  }, {})
}
export const addTabKeyToFields = (fields, key) => {
  if (isKeyPresent(fields.filter(field => field.hasOwnProperty('name')).map(field => field.name), key))
    return fields
  return fields.map(field => {
    let copy = { ...field }
    if (!!field.name)
      copy.name = `${key}.${field.name}`
    return copy
  })
}
export const stripTabKeyFromFields = (fields, key) => {
  if (!isKeyPresent(fields.filter(field => field.hasOwnProperty('name')).map(field => field.name), key))
    return fields
  return fields.map(field => {
    let copy = { ...field }
    if (!!field.name)
      copy.name = copy.name.replace(`${key}.`, '')
    return copy
  })
}
export const stripTabKeyFromOptions = (options, key) => {
  if (!isKeyPresent(Object.keys(options), key))
    return options
  return Object.entries(options).reduce((acc, [origKey, val]) => {
    let newKey = origKey.replace(`${key}.`, '')
    acc[newKey] = val
    return acc
  }, {})
}

export const generateDefaultValues = (allFields, key) => {
  return allFields.reduce((accumulator, currentField) => {
    if (currentField.hasOwnProperty('name'))
      accumulator[currentField.name.replace(`${key}.`, '')] = currentField.defaultValue;
    return accumulator;
  }, {})
}